export enum EnumTypeAccessRequest {
  CREATED = "CREATED",
  FEEDBACK = "FEEDBACK",
  UPDATED = "UPDATED",
}

export enum AccessRequestTypeEnum {
  ACCESS = "ACCESS",
  UNLOCK = "UNLOCK",
}

export enum UnlockEntityTypeEnum {
  USER = "USER",
  OPERATOR = "OPERATOR",
}

export enum StatusEnumAccessRequest {
  PENDING = "PENDING",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
  COMPLETED = "COMPLETED",
}
